export default __webpack_public_path__ + "static/media/showcase.fbfd3761.svg";